import Icon from "@components/text/Icon";
import { Colors } from "@utils/colorUtils";

type Props = {
  color?: Colors;
  size?: "small" | "tiny";
  unread: boolean;
};

const Dot = ({ color = "secondary-300", size = "tiny", unread }: Props) => {
  if (unread) {
    return <Icon color={color} data-test="unread" icon="circleSolid" size={size} />;
  }
  return null;
};

export default Dot;
